/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// `inquiry.checkList.available`が`true` の場合は常に全画面、`false`の場合はウィジェット自体をスクリーン下寄せにすることは可能でしょうか？
// @see https://jira.rakuten-it.com/jira/browse/UXDCOEIPS-194
import styled from 'styled-components';
import { BreakPoint, Color, Font } from '../../asset/styles';

const StyledBoxPopup = styled.section`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.darkRed};
  position: fixed;
  left: 0;
  top: ${props => (props.checkList ? 0 : 'auto')};
  bottom: ${props => (props.checkList ? 'auto' : 0)};
  height: ${props => (props.checkList ? '100%' : 'auto')};
  width: 100%;
  font-family: ${Font.default};
  box-sizing: border-box;

  * {
    font-family: ${Font.default};
    box-sizing: border-box;
  }

  /* desktop */
  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    max-height: ${props => 318 + 32 + props.headerHeight}px;
    width: 456px;
    height: auto;
    bottom: 32px;
    top: auto;
    left: auto;
    right: 10%;
    overflow-x: hidden;
    overflow-y: hidden;
  }
`;

const StyledBoxEmbedded = styled(StyledBoxPopup)`
  /* desktop */
  @media (min-width: ${BreakPoint.desktop}) {
    bottom: auto;
    right: auto;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
`;

export const StyledBox = ({
  embedded,
  className = '',
  headerHeight,
  checkList,
  ...props
}) => {
  return embedded ? (
    <StyledBoxEmbedded
      className={`${className} StyledBoxEmbedded`}
      headerHeight={headerHeight}
      checkList={checkList}
    >
      {props.children}
    </StyledBoxEmbedded>
  ) : (
    <StyledBoxPopup
      className={`${className} StyledBoxPopup`}
      headerHeight={headerHeight}
      checkList={checkList}
    >
      {props.children}
    </StyledBoxPopup>
  );
};

// for Mobile Safari's bug
// https://qiita.com/chocolamint/items/67d25933880404c93db0
export const StyledBoxInner = styled.div`
  overflow-x: hidden;
  position: relative;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;

  /* 640px - 72px - 18px */
  /*height: 550px;
  height: calc(100% - 72px);
  height: calc(100% - 72px - constant(safe-area-inset-bottom));
  height: calc(100% - 72px - env(safe-area-inset-bottom));
*/

  @media (min-width: ${BreakPoint.desktop}) {
    overflow-y: hidden;
    height: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/style.js